export default __webpack_public_path__ + "static/media/thumb_18.69b98701.webp";